// Framework and third-party non-UI
import React, { useContext } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridContext } from './DataGrid';

// Component specific modules (Component-styled, etc.)
import { StyledDataGridHeaderCell } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

interface DataGridHeaderCellProps {
  colSpan?: number;
  style?: React.CSSProperties;
}

const DataGridHeaderCell: React.FC<DataGridHeaderCellProps> = ({
  children,
  colSpan,
  style
}) => {
  const dataGridContext = useContext(DataGridContext);
  return (
    <StyledDataGridHeaderCell
      {...dataGridContext}
      colSpan={colSpan}
      style={style}
    >
      {children}
    </StyledDataGridHeaderCell>
  );
};

export default DataGridHeaderCell;
